import React from "react";
import { Card, Row, Col, Statistic, Progress, Timeline } from "antd";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { format } from "date-fns";
import {
  EyeOutlined,
  UserOutlined,
  FieldTimeOutlined,
} from "@ant-design/icons";

const OpenAnalytics = ({ openData }) => {
  if (!openData) return null;

  const timelineData =
    openData.openTimeline?.map((item) => ({
      time: format(new Date(item.timestamp), "MMM d, HH:mm"),
      opens: item.count,
    })) || [];

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} xl={8}>
        <Card bordered={false}>
          <Statistic
            title="Total Opens"
            value={openData.summary.totalOpens}
            prefix={<EyeOutlined />}
            valueStyle={{ color: "#1890ff" }}
            precision={2}
          />
          <Progress
            percent={openData.summary.openRate}
            status="active"
            strokeColor={{
              "0%": "#1890ff",
              "100%": "#52c41a",
            }}
            className="mt-4"
          />
        </Card>
      </Col>
      <Col xs={24} xl={8}>
        <Card bordered={false}>
          <Statistic
            title="Unique Openers"
            value={openData.summary.uniqueOpeners}
            prefix={<UserOutlined />}
            valueStyle={{ color: "#52c41a" }}
          />
          <div className="mt-4">
            <small>
              {(
                (openData.summary.uniqueOpeners /
                  openData.summary.totalRecipients) *
                100
              ).toFixed(1)}
              % of total recipients
            </small>
          </div>
        </Card>
      </Col>
      <Col xs={24} xl={8}>
        <Card bordered={false}>
          <Statistic
            title="Average Opens per User"
            value={openData.summary.averageOpensPerUser}
            prefix={<FieldTimeOutlined />}
            precision={2}
            valueStyle={{ color: "#722ed1" }}
          />
        </Card>
      </Col>

      <Col xs={24}>
        <Card
          title="Opens Timeline"
          bordered={false}
          bodyStyle={{ height: "400px" }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={timelineData}
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="time"
                tick={{ fontSize: 12 }}
                interval="preserveStartEnd"
              />
              <YAxis />
              <Tooltip />
              <Area
                type="monotone"
                dataKey="opens"
                stroke="#1890ff"
                fill="#1890ff"
                fillOpacity={0.3}
              />
            </AreaChart>
          </ResponsiveContainer>
        </Card>
      </Col>

      <Col xs={24}>
        <Card title="Recent Opens" bordered={false}>
          <Timeline
            items={
              openData.recentOpens?.map((open) => ({
                color: "blue",
                children: (
                  <>
                    <p style={{ marginBottom: 0 }}>
                      <strong>{open.email}</strong> opened the email
                    </p>
                    <small>{format(new Date(open.timestamp), "PPpp")}</small>
                  </>
                ),
              })) || []
            }
          />
        </Card>
      </Col>
    </Row>
  );
};

export default OpenAnalytics;
